import React from 'react';
import { createDispatchHook, createSelectorHook } from 'react-redux';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InstructionPaneContext = React.createContext(null);
export const useDispatch = createDispatchHook(InstructionPaneContext);
export const useSelector = createSelectorHook(InstructionPaneContext);